//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { Normalized } from '@utils/normalize';

export const getOrderedLike2BuyItems = createSelector(
  (state: ICuralateStore) => state.instagram.like2buy.items,
  (normalizedLike2BuyItems) => Normalized.getOrdered(normalizedLike2BuyItems),
);
